import React from 'react';
import styled from 'styled-components';
const CustomDivider = styled.div(({ theme }) => `
      background: ${theme.colors.gray200};
      height: 1px;
      margin: ${theme.space.x24} 0 ${theme.space.x24};
    `);
export const Divider = props => {
    return React.createElement(CustomDivider, { style: { ...props } });
};
//# sourceMappingURL=index.js.map